import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { MODAL_TYPE_PRO_MYPAGE_REPRESENTATIVE, MODAL_TYPE_PRO_MYPAGE_SEND_OFF, MODAL_TYPE_PRO_MYPAGE_ORDER, MODAL_TYPE_PRO_MYPAGE_STAFF, MODAL_TYPE_PRO_MYPAGE_REPLY, MODAL_TYPE_PRO_MYPAGE_DELETE, MODAL_TYPE_PRO_MYPAGE_DESTINATION, MODAL_TYPE_PRO_MYPAGE_CLIENT, MODAL_TYPE_PRO_MYPAGE_REVIEW, } from '../../../../actions/ModalActions';
import { propArrayShape, propBool, propShape, } from '../../../../helpers/custom-prop-types';
import { isShowModal } from '../../../../helpers/modal';
import ModalApproveRepresentative from './Modal/ModalApproveRepresentative';
import ModalChangeDestination from './Modal/ModalChangeDestination';
import ModalChangeRepresentative from './Modal/ModalChangeRepresentative';
import ModalChangeStaff from './Modal/ModalChangeStaff';
import ModalClientDetail from './Modal/ModalClientDetail';
import ModalClientReplay from './Modal/ModalClientReplay';
import ModalConfirmOrder from './Modal/ModalConfirmOrder';
import ModalConfirmSendOff from './Modal/ModalConfirmSendOff';
import ModalDeleteSolution from './Modal/ModalDeleteSolution';
import ModalProposalAlert from './Modal/ModalProposalAlert';
import ModalReview from './Modal/ModalReview';
const ModalSelector = ({ isModalChangeDestinationShown, isModalChangeRepresentativeShown, isModalChangeStaffShown, isModalClientDetailShown, isModalClientReplayShown, isModalConfirmOrderShown, isModalConfirmSendOffShown, isModalDeleteSolutionShown, isModalReviewShown, list, profile, }) => {
    // 放置
    const proposal = list.find((item) => !!item.orders.find((o) => o.proposalAlert));
    const proposalSolution = proposal && proposal.solution;
    const proposalOrder = proposalSolution && proposal.orders.find((o) => o.proposalAlert);
    if (proposalSolution && proposalOrder) {
        return (_jsx(ModalProposalAlert, { order: proposalOrder, solution: proposalSolution }));
    }
    // 責任者の承諾
    const approve = list.find(({ solution }) => solution.representativeCandidateId === profile.id);
    if (approve) {
        return _jsx(ModalApproveRepresentative, { solution: approve.solution });
    }
    if (isModalChangeRepresentativeShown)
        return _jsx(ModalChangeRepresentative, {});
    if (isModalChangeDestinationShown)
        return _jsx(ModalChangeDestination, {});
    if (isModalDeleteSolutionShown)
        return _jsx(ModalDeleteSolution, {});
    if (isModalClientDetailShown)
        return _jsx(ModalClientDetail, {});
    if (isModalClientReplayShown)
        return _jsx(ModalClientReplay, {});
    if (isModalChangeStaffShown)
        return _jsx(ModalChangeStaff, {});
    if (isModalConfirmOrderShown)
        return _jsx(ModalConfirmOrder, {});
    if (isModalConfirmSendOffShown)
        return _jsx(ModalConfirmSendOff, {});
    if (isModalReviewShown)
        return _jsx(ModalReview, {});
    return null;
};
ModalSelector.propTypes = {
    isModalChangeDestinationShown: propBool().isRequired,
    isModalChangeRepresentativeShown: propBool().isRequired,
    isModalChangeStaffShown: propBool().isRequired,
    isModalClientDetailShown: propBool().isRequired,
    isModalClientReplayShown: propBool().isRequired,
    isModalConfirmOrderShown: propBool().isRequired,
    isModalConfirmSendOffShown: propBool().isRequired,
    isModalDeleteSolutionShown: propBool().isRequired,
    isModalReviewShown: propBool().isRequired,
    list: propArrayShape().isRequired,
    profile: propShape().isRequired,
};
const mapStateToProps = ({ modal, professionalMySolution }) => {
    const list = (professionalMySolution || {}).allList || [];
    return {
        isModalChangeDestinationShown: isShowModal(modal, MODAL_TYPE_PRO_MYPAGE_DESTINATION),
        isModalChangeRepresentativeShown: isShowModal(modal, MODAL_TYPE_PRO_MYPAGE_REPRESENTATIVE),
        isModalChangeStaffShown: isShowModal(modal, MODAL_TYPE_PRO_MYPAGE_STAFF),
        isModalClientDetailShown: isShowModal(modal, MODAL_TYPE_PRO_MYPAGE_CLIENT),
        isModalClientReplayShown: isShowModal(modal, MODAL_TYPE_PRO_MYPAGE_REPLY),
        isModalConfirmOrderShown: isShowModal(modal, MODAL_TYPE_PRO_MYPAGE_ORDER),
        isModalConfirmSendOffShown: isShowModal(modal, MODAL_TYPE_PRO_MYPAGE_SEND_OFF),
        isModalDeleteSolutionShown: isShowModal(modal, MODAL_TYPE_PRO_MYPAGE_DELETE),
        isModalReviewShown: isShowModal(modal, MODAL_TYPE_PRO_MYPAGE_REVIEW),
        list,
    };
};
const enhance = compose(connect(mapStateToProps));
export default enhance(ModalSelector);
